import { render } from "./ReportQuestions.vue?vue&type=template&id=7876c7f1&ts=true"
import script from "./ReportQuestions.vue?vue&type=script&lang=ts"
export * from "./ReportQuestions.vue?vue&type=script&lang=ts"

import "./ReportQuestions.vue?vue&type=style&index=0&id=7876c7f1&lang=css"
import "./ReportQuestions.vue?vue&type=style&index=1&id=7876c7f1&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__